import React from 'react';
import { useTranslation } from 'react-i18next';
import Checkbox from './Checkbox';

/**
 * The staff "don't send to the customer" choice (design 2026-10-03), shared by
 * every screen and modal that issues an in-scope document.
 *
 * NEGATIVE polarity on purpose: unticked — the default on every screen — is
 * today's behaviour (issued AND messaged). Ticking it skips only the customer
 * message; the document is still created, numbered and reported to ZATCA,
 * which the hint says out loud.
 *
 * The parent owns the state and posts `notify_customer: !dontSend`. onChange
 * hands the parent the plain boolean (not the event), so `onChange={setDontSend}`
 * works as-is.
 *
 * <NotifyCustomerCheckbox checked={dontSend} onChange={setDontSend} disabled={bool} />
 */
const NotifyCustomerCheckbox = ({ checked, onChange, disabled = false, className = '' }) => {
  const { t } = useTranslation();
  return (
    <div data-testid="notify-customer-checkbox" className={className}>
      <Checkbox
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="w-5 h-5 shrink-0 mt-0.5"
        label={t('notify.dontSend')}
        hint={t('notify.dontSendHint')}
      />
    </div>
  );
};

export default NotifyCustomerCheckbox;
